import { Message, Stack, toaster, Notification } from 'rsuite';
import infoIcon from '../../images/account/info.svg';
import errorIcon from '../../images/account/error.svg';
import warningIcon from '../../images/account/warning.svg';

interface IErrorProps {
  toaster: any;
  error: any;
  title?: string;
}
export const ErrorToaster = ({ toaster, error, title }: IErrorProps) => {
  const res = error as Record<string, any>;
  const code = res?.data?.error_code || res?.status || '';
  const message =
    res?.data?.error_desc ||
    res?.data?.message ||
    res?.data?.detail ||
    res?.data?.details ||
    '';
  const errMessage = (
    <Message type="warning" closable header={title}>
      <div>
        <div>
          {code && (
            <Stack spacing={12}>
              <b>Error Code:</b> <span>{code}</span>
            </Stack>
          )}
        </div>
        <div>
          {message && (
            <Stack spacing={12}>
              <b>Detail:</b> <span>{message}</span>
            </Stack>
          )}
        </div>
      </div>
    </Message>
  );
  toaster.push(errMessage, {
    placement: 'bottomEnd',
    duration: 5000
  });
};
interface IWarningProps {
  // toaster: any;
  message?: string;
  type?: any;
}

export const SocWarning = ({ message, type }: IWarningProps) => {
  console.log('--------- soc warning:', type, message);
  const color =
    type === 'error'
      ? '#D4352780'
      : type === 'info'
        ? '#4A7AF180'
        : '#F2B44D4D';
  return (
    <Notification
      closable
      type={type || 'warning'}
      style={{ background: `${color}` }}
    >
      {/* {type === 'warning' && (
        <img src={warningIcon} style={{ marginRight: '20px' }} />
      )}
      {type === 'error' && (
        <img src={errorIcon} style={{ marginRight: '20px' }} />
      )}
      {type === 'info' && (
        <img src={infoIcon} style={{ marginRight: '20px' }} />
      )} */}
      {message}
    </Notification>
  );
};
